import { BCMSDate, DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { Autopay, Bill, Biller } from "model";
import "./styles.css";

import { useActivityPageContext } from "compid/pages/ActivityPage";
import WidgetContainer from "compid/shared/containers/WidgetContainer";
import WidgetHeaderView from "compid/shared/containers/WidgetContainer/views/WidgetHeaderView";
import BillerTileView from "compid/shared/views/BillerTileView";
import TableView, { TableRowView } from "compid/shared/views/TableView";
import { ImageAsset, SVGAsset } from "res";

import NoAutopayWidget from "../NoAutopayWidget";

export default function ActiveAutopaysWidget(props) {
    const { state } = useActivityPageContext();
    const selectedBiller = state.filters.search instanceof Biller ? state.filters.search : undefined;
    
    // Only autopays for the searched biller should appear.
    // If no biller has been searched, show all autopays.
    const bills = Bill.initAll()
        .filter(bill => {
            if(!selectedBiller) { return true; }
            return bill.biller.id === selectedBiller.id;
        })
        .filter(bill => bill.biller.autopay instanceof Autopay, [])
        .map(bill => {
            const biller = bill.biller;
            const autopay = biller.autopay;
            // Check which date should be used
            const payDate = autopay.deliverBy instanceof BCMSDate ? autopay.formatDate(): bill.formatDate;
            let payAmount;
            // Check which amount should be used
            if(autopay.alwaysPay === "Fixed amount") { payAmount = autopay.fixed.format(); }
            else if(autopay.alwaysPay === "Amount due") { payAmount = autopay.maximum.format(); }
            else { payAmount = autopay.alwaysPay.format(); }

            // Return a "div" instead of a fragment "<></>" or "<React.Fragment></React.Fragment>"
            // since attempting to filter fragments will break the component.
            return (
                <div className="flex-container flex-vertical active-autopay" key={ `bill_${ bill.id }` }>
                    <BillerTileView
                        dataPoint={ `Active_Autopay_Biller_${ biller.id }` }
                        name={ biller.name }
                        accountNumber={<>{biller.nickname} { biller.number }</>}
                        className="show-on-desktop"
                        logo={<ImageAsset id={biller.logo} className="logo-icon" />} >
                        <TableView>
                            <TableRowView labelClass="gray-text sub-text" dataClass="text-right sub-text" label="Pay From" data={ autopay.payFrom.name + " " + autopay.payFrom.number } dataPoint={ `Active_Autopay_From_${ biller.id }` } />
                            <TableRowView labelClass="gray-text sub-text" dataClass="text-right sub-text" label="Pay Amount" data={ payAmount } dataPoint={ `Active_Autopay_Amount_${ biller.id }` } />
                            <TableRowView labelClass="gray-text sub-text" dataClass="text-right sub-text" label="Deliver By" data={ autopay.frequency } dataPoint={ `Active_Autopay_Deliver_${ biller.id }` } />
                        </TableView>
                    </BillerTileView>

                    <DisabledPrompt>
                        <Link to="/" className="text-right view-autopay">
                            <p>
                                <span data-point={ `Active_Autopay_View_Autopay_${ biller.id }` }>View autopay</span>
                            </p>
                        </Link>
                    </DisabledPrompt>
                </div>
            );
        }, []);

    return (
        <WidgetContainer className="active-autopays-widget">
            <WidgetHeaderView title={
                <div className="flex-container flex-horizontal align-center">
                    Active Autopays
                    <SVGAsset id="InfoIcon" className="right-icon header-icon" />
                </div>
            } dataPoint="Activity_Active_Autopays_Header">
      
            </WidgetHeaderView>

            { bills.length > 0
                    ? bills
                    : <NoAutopayWidget /> }

            {/* { bills.length > 0 && <Link to="/" className="set-width blue-text link text-right">View autopays</Link> } */}
        </WidgetContainer>
    );
}